import Vue from "vue";

let transTable = {
    'zh-CN': {
        'prodInfo': '产品信息',
        'prodName': '产品名称',
        'prodId': '产品编号',
        'backendMgr': '后台管理',
        'rtnHome': '返回首页',
        'prod': '产品',
        'order': '订单',
        'prodMgr': '产品管理',
        'prodClassMgr': '产品类别管理',
        'orderMgr': '订单管理',
        'rcverInfo': '收件人资讯',
        'rcverName': '收件人名称',
        'rcverEmail': '收件人信箱',
        'rcverPhone': '收件人电话',
        'rcverAddr': '收件人地址',
        'addr': '地址',
        'zip': '邮递区号',
        'buyerInfo': '购买人资讯',
        'name': '姓名',
        'email': '信箱',
        'phone': '电话',
        'orderId': '订单编号',
        'orderStatus': '订单状态',
        'deliInfo': '运送资讯',
        'buyRecord': '购物记录',
        'created_at': '创建时间',
        'totalPrice': '总价格',
        'subPrice': '小计',
        'notPaid': '尚未付款',
        'paid': '已付款',
        'newProdClass': '新增产品类别',
        'edProdClass': '编辑产品类别',
        'prodClass': '产品类别',
        'cancel': '取消',
        'confirm': '确定',
        'prodCategory': '产品种类',
        'item': '项目',
        'itemPrice': '项目价格',
        'checkout': '结帐',
        'commentField': '注释栏位',
        'commentContent': '注释内容',
        'comment': '注释',
        'fileImport': '文件汇入',
        'uploadFile': '上传文件',
        'uploadImg': '上传图片',
        'uploadFileSuccessMsg': '上传成功，资料已经汇入完成',
        'reset': '重置',
        'all': '全部',
        'newProd': '新增产品',
        'prodImport': '汇入产品',
        'importRelatedFile': '汇入产品关联档案',
        'edit': '编辑',
        'new': '新增',
        'data': '资料',
        'downloadFiles': '档案下载',
        'uploadRelatedProdFile': '上传产品关联档案',
        'prodImg': '产品图片',
        'filterItem': '过滤项目',
        'relatedFile': '关联档案',
        'operate': '操作',
        'limitedFile': '受限档案',
        'inquiry': '询价',
        'count': '数量',
        'newPass': '新密码',
        'newPassConfirm': '新密码确认',
        'confirmChange': '确定更改',
        'prodAndService': '公司产品和服务',
        'GMPProdPeptide': 'GMP生产多肽',
        'pepSyn': '多肽合成仪',
        'aboutUs-sentence-1': '希施生物科技（上海）有限公司拥有全球最完整和技术含量高的多肽产业的生产基地，其产品涵盖了多肽合成、GMP生产多肽，客户定制生产多肽、常用多肽、磷酸化多肽、多肽环化、多肽偶联、多肽修饰。同时，围绕着多肽产业，希施生物科技还形成了庞大的上、下游产品链，上游产品包括：各类多肽试剂，氨基酸、保护氨基酸、Fmoc-氨基酸、Boc-氨基酸、特殊氨基酸、缩合剂、固相树脂-等产品；下游产品包括：抗体、单克隆抗体、定制生产多抗。经过20年多时间的发展，已经成为全球的主要多肽产业生产供应商之一。',
        'aboutUs-sentence-2': '希施生物科技拥有经FDA审核通过的GMP多肽生产基地，能提供全系列的GMP生产多肽和定制多肽！我们的目标就是要提供最高质量多肽产品给我们的客户,并在规定的时间内符合客户要求！我们的员工拥有高超多肽生产知识和技术水平，也非常熟知GMP的要求！我们质量部每年都会进行持续性的GMP培训并做好培训记录。 <br>我们对质量的承诺和遵守的是我们公司运作的驱动力。我们欢迎老客户和潜在的客户来审核我们的GMP生产基地！假如你有任何关于我们的GMP生产多肽的问题，请随时联系我们！',
        'aboutUs-sentence-3': '希施生物科技拥有20多年生产合成仪的经验能提供不同型号的全自动多肽合成仪用于非GMP和GMP级别多肽生产！',
        'home-sentence-1': '我们的理念是客户的利益至上，并向新型多肽企业迈进',
        'home-sentence-2': '我们的使命是提供最优质的产品和优秀的客户服务',
        'home-sentence-3': '我们的愿景是成为全球多肽解决方案提供商',
        'csbio': '希施',
        'home': '首页',
        'prodList': '产品列表',
        'memCenter': '会员中心',
        'orderList': '订单列表',
        'cart': '购物车',
        'logout': '登出',
        'memLogin': '会员登入',
        'bookName': '订购人姓名',
        'bookPhone': '订购人电话',
        'bookEmail': '订购人信箱',
        'filter': '过滤器',
        'choice': '请选择',
        'lastStep': '上一步',
        'createOrder': '建立订单',
        'price': '单价',
        'cartEmpty': '购物车为空的',
        'nextStep': '下一步',
        'registerEmail': '注册信箱',
        'pass': '密码',
        'login': '登入',
        'register': '注册',
        'forgetPass': '忘记密码',
        'passConfirm': '密码确认',
        'memInfo': '会员资料',
        'resendVerify': '重新发送验证信',
        'changePass': '更变密码',
        'waitPay': '等待付款',
        'send': '传送',
        'rcvAddr': '收件地址',
        'aboutUs': '关于我们',
        'siteMap': '站点地图',
        'ourHonor': '企业荣耀',
        'careers': '招聘',
        'news': '新闻',
        'contactUs': '联系我们',
        'latestNews': '最新消息',
        'introd': '产品介绍',
        'peptide': '多肽',
        'pepReag': '多肽试剂',
        'qulityCtrl': '质量管理',
        'pep-gmp-sentence-1': '希施生物科技拥有经FDA审核通过的GMP多肽生产基地，能提供全系列的GMP生产多肽和定制多肽！我们的目标就是要提供最高质量多肽产品给我们的客户,并在规定的时间内符合客户要求！我们的员工拥有高超多肽生产知识和技术水平，也非常熟知GMP的要求！我们质量部每年都会进行持续性的GMP培训并做好培训记录。\n\n我们对质量的承诺和遵守的是我们公司运作的驱动力。我们欢迎老客户和潜在的客户来审核我们的GMP生产基地！假如你有任何关于我们的GMP生产多肽的问题，请随时联系我们！',
        'pep-cus-sentence-1': '我们懂多肽',
        'pep-cus-sentence-2': '希施生物科技有多年历史悠久和丰富的客户定制多肽合成服务,多肽修饰以及多肽文库的经验。我们多肽基地生产过上万种的多肽；从线性肽到非常复杂多肽包括不同类型的多肽修饰（请看我们的修饰列表），多肽订量从微量毫克到公斤级，不一样的纯度（粗品到98%以上纯度）按不同客户应用要求例如抗体研究、功能分析尤其是新药物开发等领域！在客户下订单之前，我们将为多肽用户提供免费专业多肽技术咨询已让客户对的多肽序列设计有更深入的了解和选择空间！\n\n身为希施的尊贵的客户，我们会不辞余力为你提供你多肽订单的生产全过程信息到你收到多肽产品后，我们还是会不间断和你保持联系已以确保你实验能顺利完成！\n\n我们承诺客户可靠的高质量，性价比高据有竞争力的价格价格和优越的客户服务是客户始终相信希施来完成他们的研发工作！',
        'pep-cus-sentence-3': '客户定制生产多肽 2013价格 (non-GMP)',
        'pep-cus-sentence-4': '多肽修饰列表',
        'pep-cus-sentence-5': '如何订购多肽\n\n● 我们报价是人民币含税价（利率换算：1US$：7.3人民币）\n\n● 多肽价目表是以每个氨基酸残基来计算法，例如：一条100毫克15个氨基酸残基纯度95%的多肽 (不带修饰) 15个（酸残基) x$30.80 (单价) 100毫克，纯度95% ) = US$462等于人民币3372.60\n\n● 每个批次的多肽产品都会附上质谱，液相色谱图，自检单等等质量文件。\n\n● 我们也能提供多肽合成工艺图\n\n● 关于多肽修饰的选择，请参考我们的修饰列表！基本上我们都可以提供除非不能再国内找到的原料！我们也 接受客户提供原料，我们不会收取任何额外的修饰！\n\n● 生产周期：去盐多肽一周以内，正常纯化多肽2周可以完成\n\n● 我们会收取7元一管的多肽分包装费用！\n\n● 国内快递发货可以在2-3天到达客户，费用是人民币30元\n\n● 假如客户需要低温运输，我们也能提供不过需要收取额外的费用！\n\n● 我们承诺客户多肽信息将受到保密，有需要我们非常乐意签署保密协议！\n\n● 您可以任选一种方式向希施生物科技(上海)有限公司定购多肽:\n\n— 邮件订购：客户发正式订购多肽订单到我们邮箱，多肽订购邮箱peptideorder@csbiochina.com确认多肽定\n制订单。我们将在24小时以内已邮件，传真或电话确订单认\n\n— 传真订购：客户发正式订购多肽订单至我们公司传真：021-50781661-8008您可以向我们的销售工程师\n索取合同文件，填写完整并盖上有效的公章后传真至021-。我们的客服人员会在半小时之内与您确认完\n成产品的订购合同。\n\n— 在线浏览订购：您可以直接访问希施生物科技（上海）有限公司企业网站的产品目录页面进行产品浏\n览，点击您感兴趣相关的产品链接，在产品详细介绍页面的下面点击订购，输入您的要求即可。我们在\n收到您的订购信息后会与您联系\n\n— 在线搜索定购：您可以通过产品搜索功能搜索我们的产品，然后在相关的产品详细介绍页面的下面点击\n订购，输入您的要求即可。我们在收到您的订购信息后会与您联系\n\n— 在线客户定制：您也可以通过点击客户定制输入您要求的产品资料，点击提交进行定购。\n\n— 电话订购流程：您可以致电销售电话021-50781660，告诉我们您需要的肽的序列，数量和纯度。 我们的\n销售人员将在24小时内给您报价,并致电和您协商价格，包装等内容，同时将内容制作成合同以传真或者\n邮件的形式给您，待您确认合同内容 确认后，我们会按合同给您安排生产发货直至合同履行完毕\n\n需要更多信息请可以发邮件到info@csbiochina.com\n\n公司户名：希施生物科技（上海）有限公司\n公司帐号： 50100001110027714\n开户银行： 上海华一银行\n银行地址：上海市浦东新区浦东南路360号新上海国际大厦1楼，电话：021-58881234',
        'popularPeptide': '常规多肽',
        'pop-pep-sentence-1': '希施生物科技提供一系列非常全面常用多肽用于多肽研发。我们常用多肽产品都是预分包装立即可以使用。我们针对这些常用多肽进行非常完整的质量检测保证包括HPLC分析纯度和质谱分析来确认多肽。请随时咨询我们公司网站或联系我们关于你所需要的多肽名称，多肽序列或相关多肽研发类别。假如你没有找到你所关注的多肽，我们可以按你的要求为你定制多肽。请发邮件给我们（邮箱：info@csbiochina.com) 或访问我们的公司网站：https://www.csbio.com/shop-peptides',
        'pep-cov19-sentence-1': 'SARS病毒是一种囊膜病毒，都是通过囊膜融合蛋白和细胞膜的受体结合而侵入细胞。利用竞争抑制病毒的原理，我们可以抢先占据SARS病毒囊膜融合蛋白的融合位点，使之失去和人体细胞的融合位置。SARS病毒全基因序列公布后，我们可以查到几段与其它囊膜病毒融合蛋白类似的氨基酸序列。如同其它囊膜病毒融合蛋白的氨基酸序列，这两段氨基酸序列也有“保守”的特点，不同的变种差异也不会太大。我们可以通过合成这两段氨基酸序列制成多肽药物，利用其可以抢先结合病毒融合蛋白本身融合位点，从而阻断病毒的感染途径。而我们可以了解到SARS的病理特征与COVID-19和MERS感染者的病理特征极其相似，而且三种疾病的致病病毒都属于β冠状病毒属，所以我们可以考虑利用相同的原理利用多肽药物把病毒阻止在细胞之外。\n\n希施生物致力于为全球科研单位提供新冠病毒(SARS&MERS&COVID-19)研究级多肽，以丰富的经验设计了多种新冠病毒相关多肽为客户提供全方位多肽解决。',
        'pep-cov19-sentence-2': '希施简介',
        'pep-cov19-sentence-3': 'CSBio是一家成立27年的全方位多肽公司，可提供3大类产品：\n1)多肽CDMO & CMO服务－GMP和研发多肽生产，有USFDA认证API多肽生产资质\n2)多肽研发和生产设备－从研发到生产型合成仪，裂解仪，纯化制备，装柱机，多肽实验室和生产车间技术支持\n3) 多肽重要原料－ 保护标准和高质量氨基酸和多肽试剂，有相关验证数据，稳定性数据和DMF技术文件支持.我们基本上是一家多肽全方位产品和服务公司。\n4）寡核苷酸合成仪-可用于研发、工艺开发和生产。',
        'pep-cov19-sentence-4': '希施生物科技（上海）有限公司',
        'pep-cov19-sentence-5': '中国（上海）自由贸易试验区法拉第路85号，2幢502室\n邮编：201210\n邮箱：info@csbiochina.com\n电话：+8621-50781653/50781655\n传真：+8621-50781652/021-50781656\n网站：www.csbiochina.com www.csbio.com',
        'pep-pet-sentence-1': '现代医学诊断学研究中，分子成像技术（正电子发射断层显像）日趋重要，因为它不但具有较高的专一性，而且能给研究者提供分子水平的生物学信息。多肽分子经标记后成为一类分子探针，可应用于分子成像技术以满足各种药理学研究（例如：疾病的早期诊断、疾病发展的潜在生化过程的实时可视化以及疾病治疗整个过程的跟踪）。',
        'cusManuPep': '客户定制生产多肽',
        'petPepAndPretty': 'PET多肽和美容肽',
        'cov19Introd': '新冠病毒相关介绍',
        'aminoAcidsResins': '氨基酸和树脂',
        'pepReag-AAR-sentence-1': '希施生物科技拥有全球最完整和技术含量高的多肽相试剂，还形成了庞大的上、下游产品链，上游产品包括：各类氨基酸和固相树脂-等产品；经历20年多时间的发展，已经成为全球的主要多肽产业生产供应商之一。\n\n希施生物科技经过二十多年的发展，已经成为全球的主要多肽产业生产供应商之一。\n\n● 各类氨基酸和相关衍生物\n● 各类氨基酸和相关衍生物氨基醇\n● Boc-氨基酸和相关衍生物\n● Fmoc-氨基酸和相关衍生物\n● 链接剂\n● N甲基-氨基酸和相关衍生物\n● N端保护剂\n● 其他常用多肽试剂\n● 多肽缩合剂\n● 特殊氨基酸\n● 特殊树脂\n● Z-氨基酸和相关衍生物\n请随时询问我们假如你找不到想要的氨基酸和树脂！我们会尽快回复库存量和价格',
        'aminoAcidsCartridges': '氨基酸试剂盒',
        'pepReag-AAC-sentence-1': '希施生物科技拥有全球最完整和技术含量高的氨基酸试剂盒用于我们的多款多肽合成仪！让你在使用我们的合成仪时没有后顾之忧！请随时询问我们假如你找不想要的氨基酸和树脂！我们会尽快回复库存量和价格',
        'fineChemicals': '精细化工',
        'pepReag-FC-sentence-1': '希施生物科技向国际化工用户提供特别针对国内和亚洲化工品的对外包服务。我们的强大供应管理团队能和供应商协力确保产品质量。我们质量部能对供应商进行系统质量审核和产品质量确认。请随时和我们洽谈！',
        'reagForDnaRnaSyn': 'DNA/RNA合成仪配套试剂',
        'pepReag-RFDRS-sentence-1': '希施简介',
        'pepReag-RFDRS-sentence-2': 'CSBio是一家成立27年的全方位多肽公司，可提供3大类产品：\n1)多肽CDMO & CMO服务－GMP和研发多肽生产，有USFDA认证API多肽生产资质\n2)多肽研发和生产设备－从研发到生产型合成仪，裂解仪，纯化制备，装柱机，多肽实验室和生产车间技术支持\n3) 多肽重要原料－ 保护标准和高质量氨基酸和多肽试剂，有相关验证数据，稳定性数据和DMF技术文件支持.我们基本上是一家多肽全方位产品和服务公司。\n4）寡核苷酸合成仪-可用于研发、工艺开发和生产。',
        'pepReag-RFDRS-sentence-3': '希施生物科技（上海）有限公司',
        'pepReag-RFDRS-sentence-4': '中国（上海）自由贸易试验区法拉第路85号，2幢502室\n邮编：201210\n邮箱：info@csbiochina.com\n电话：+8621-50781653/50781655\n传真：+8621-50781652/021-50781656\n网站：www.csbiochina.com www.csbio.com',
        'qualAss': '质量保证',
        'qualAss-qualAss-sentence-1': '希施生物科技以质量做为管理宗旨和企业文化。确保客户满意是我们为每位客户提供的承诺！我们的员工均经过专业的质量培训，理解质量对于客户的重要程度，严格贯彻执行质量标准！我们的产品在发货前都经过严格检测和验证，以确保客户收到的产品无后顾之忧。每批产品均附有详细的质检单，分析条件，分析数据，稳定性数据等一系列详细数据。 我们也会和供货商合作，以确保供货商提供的原料符合我们的质量要求！\n\n在产品质量控制中，我们采用以下技术：',
        'qualAss-qualAss-sentence-2': '除了以上质量体系，我们也尽力提供以下文件来支持客户GMP要求！',
        'qualAss-qualAss-orderlist1-item1': '纯度(高效液相色谱仪)',
        'qualAss-qualAss-orderlist1-item2': '薄层色谱法',
        'qualAss-qualAss-orderlist1-item3': '电喷雾质谱',
        'qualAss-qualAss-orderlist1-item4': '核磁共振',
        'qualAss-qualAss-orderlist1-item5': '手性高效液相',
        'qualAss-qualAss-orderlist1-item6': '离子色谱',
        'qualAss-qualAss-orderlist1-item7': '比旋光度',
        'qualAss-qualAss-orderlist1-item8': '卡尔费休滴定',
        'qualAss-qualAss-orderlist1-item9': '酸碱滴定法',
        'qualAss-qualAss-orderlist1-item10': '紫外-可见光光谱分析',
        'qualAss-qualAss-orderlist1-item11': '金属夹杂物分析',
        'qualAss-qualAss-orderlist1-item12': '元素分析',
        'qualAss-qualAss-orderlist1-item13': '氨基酸分析',
        'qualAss-qualAss-orderlist2-item1': '供应商声明问卷',
        'qualAss-qualAss-orderlist2-item2': '来源证明',
        'qualAss-qualAss-orderlist2-item3': '非转基因声明',
        'qualAss-qualAss-orderlist2-item4': '产品合成路线',
        'qualAss-qualAss-orderlist2-item5': '三聚氰胺申报',
        'qualAss-qualAss-orderlist2-item6': '变更申明',
        'qualAss-qualAss-orderlist2-item7': '潜在杂质列表',
        'qualAss-qualAss-orderlist2-item8': '1类溶剂，满足监管要求',
        'qualAss-qualAss-orderlist2-item9': '仪表清单',
        'qualAss-qualAss-orderlist2-item10': '溶剂和催化剂清单',
        'qualAss-qualAss-orderlist2-item11': '材料安全数据表',
        'csbioAnalyServices': '希施分析服务',
        'qualAss-CAS-sentence-1': 'CSBio 高可信度的品质，并且我们提供合格的产品给我们全世界的客户。因此我们有齐全的品管实验室以及必要的状态分析仪器。我们也提供分析测试服务给想外包来检测产品品质的客户。',
        'qualAss-CAS-orderlist-title1': '质谱分析',
        'qualAss-CAS-orderlist-1-1': '电喷雾-质谱',
        'qualAss-CAS-orderlist-1-2': '液相色谱 质谱联用',
        'qualAss-CAS-orderlist-1-3': '液相二级质谱，是将经过第一次质谱检测的离子以某种方式碎裂后再进行质谱检测',
        'qualAss-CAS-orderlist-title2': '液相分析',
        'qualAss-CAS-orderlist-2-1': '反相高效液相色谱分析法',
        'qualAss-CAS-orderlist-2-2': '高效体积排阻色谱法',
        'qualAss-CAS-orderlist-2-3': '离子液相',
        'qualAss-CAS-orderlist-2-4': '针对非药品生产质量管理规范范项目的方法开发和验证',
        'qualAss-CAS-orderlist-title3': '核磁共振分析',
        'qualAss-CAS-orderlist-title4': '红外分析服务',
        'qualAss-CAS-orderlist-title5': '手性液相分析服务',
        'qualAss-CAS-orderlist-title6': '氨基酸分析服务',
        'qualAss-CAS-orderlist-6-1': '蛋白、多肽经盐酸水解释放氨基酸残基后能被柱前衍生化反相高效液相色谱分析法',
        'qualAss-CAS-orderlist-title7': '水分测试',
        'qualAss-CAS-orderlist-7-1': '卡尔-费休滴定分析水分',
        'qualAss-CAS-orderlist-title8': '肽含量',
        'qualAss-CAS-orderlist-8-1': '元素分析',
        'qualAss-CAS-orderlist-title9': '肽抗衡离子含量',
        'qualAss-CAS-orderlist-9-1': '用离子液相来测三氟乙酸,冰醋酸含量',
        'qualAss-CAS-orderlist-title10': '残留溶剂含量',
        'qualAss-CAS-orderlist-10-1': '气相色谱N,N-二甲基甲酰胺，甲醇，乙腈',
        'qualAss-CAS-orderlist-title11': '熔点',
        'qualAss-CAS-orderlist-title12': '元素分析',
        'qualAss-CAS-orderlist-12-1': '分析有机化工品的碳，氢，氮等等含量',
        'qualAss-CAS-orderlist-title13': '多肽分析测试',
        'qualAss-CAS-orderlist-title14': '多肽类产品冻干服务',
        'preHplcAndCol': '制备液相\n系统',
        'phac-phhs-sentence-1': '希施生物为用户提供不同规模的高压液相制备系统和色谱柱。我们提供的制备液相系统可用于发酵类药物﹑天然产物类原料药﹑多肽类药物﹑医药中间体和化工中间体的制备分离。',
        'phac-phhs-sentence-2': '希施生物添加纯化设备到我们的自动化肽合成仪产品系列，使我们能够提供从多肽合成到最终纯化的完整服务和设备。',
        'semiPrepHplcSys': '半制备液相\n系统',
        'phac-sphs-sentence-1': 'GL6000系列25ml-250ml最大流量泵头，SAC & DAC 25.4mm-100mm半制备色谱柱。',
        'phac-sphs-sentence-2': '系統配置',
        'pilotPreHplcSys': '中试制备型\n液相系统',
        'phac-pphs-sentenct-1': 'GL6000系列 500ml-1L最大流量泵头，DAC100mm-200mm制备色谱柱',
        'phac-pphs-sentenct-2': '系統配置',
        'indusPrepHplcSys': '工业制备型DAC\n液相系统',
        'phac-iphs-sentenct-1': '● GL6000系列 2L-20L最大流量泵头，DAC200mm-800mm制备色谱柱\n● 防爆隔膜泵\n● 系统硬件和软件支持GMP/21CRF11，3Q。',
        'phac-iphs-sentenct-2': '工业制备型DAC液相系统',
        'csbioProdListTitle-1': 'CSBio',
        'csbioProdListTitle-2': '产品列表',
        'instru-ncsbio-title-1': '希施生物新品发布：CSBio II 研发级多肽合成仪',
        'instru-ncsbio-content-1': 'CSBio II是一款全自动多肽合成仪，用于合成50mg至500mg规模多肽。\n\n这是一款市场上最经济的研发型多肽合成仪，CSBio II多肽合成仪的设计对于没有合成经验的用户也很容易操作，使用人员在实验室就可以很容易的合成多肽。',
        'instru-ncsbio-title-2': 'CSBio II 合成仪',
        'instru-cs136-sentence-1': 'CS136系列是以研发级多肽合成仪为特点的，这系列合成仪可用于研发，工艺开发和小规模生产。CS136系列合成仪的反应瓶尺寸从10ml至250ml，该型号合成仪使用180度翻转混合方式来达到树脂和溶剂的充分接触。CS136系列合成仪还提供在线紫外监测作为选配项并用于脱保护过程的监测，同时该系列合成仪还有加热装置选配项可用于合成过程中的关键的洗涤，缩合和脱保护循环。',
        'instru-cs136-sentence-2': 'CS136M这款合成仪是基于广受欢迎的CS136X平台，该平台具有灵活多肽合成的最强大技术，并能为高通量用户提供同时合成6条多肽的能力。\n\nCS136M用于研发大批量小规模多肽生产。该型号合成仪可以使用尺寸范围20ml至100ml的反应瓶并采用我们180度翻转专利技术，可以实现溶剂和树脂的充分接触，CS136M可根据客户要求进行定制。标准选项包括用于加热控制的夹套反应器，自动软件集成的加热循环水浴，紫外监控和方便使用的触屏电脑系统。',
        'instru-cs536-sentence-1': 'CS536被设计用于中试规模，使用单通道批生产，这款合成仪被广泛用于工艺开发和放大开发。CS536合成仪的合成规模要大于CS136系列，CS536也可以使用180度翻转搅拌或者顶置搅拌方式。',
        'instru-cs936-sentence-1': 'CS936系列合成仪是CS Bio公司大规模生产型系统，包括CS936S,CS936和CS936X。最小规模的CS936S反应釜尺寸从500ml到5L，而CS936X的反应釜尺寸最大，从50L到1000L。这些生产型系统是世界上最大的而且最有效的自动多肽合成仪。',
        'instru-drs-sentence-1': '来自CSBio的CS-OLIGO-D是一种全自动DNA / RNA寡核苷酸合成仪，可用于研发，工艺开发和生产。\n\n这套系统配备180度翻转搅拌反应瓶，冲洗以及反应瓶再循环等功能。这些功能允许大批量树脂溶胀，通过DNA合成的传统冲洗和用于RNA合成的再循环功能。',
        'home-about-our-company': '关于我们的公司',
        'home-content-1': '多肽合成仪',
        'home-content-2': '多肽',
        'home-content-3': '多肽试剂',
        'home-content-4': '质量管理',
        'home-content-5': '制备液相系统',
        'home-content-6': '上海公司企业微信',
        'pageMgr': '页面管理',
        'carouselMgr': '轮播管理',
        'deleteConfirm': '确定要删除!?',
        'agent': '代理',
        'agent-index-sentence-1': '多肽研究所',
        'agent-index-sentence-2': '希施生物科技（上海）有限公司非常荣幸的向国内广大高端生物科技用户宣布：从2015年7月开始，我们正式成为日本Peptide Institute在中国的唯一代理商。 \nPeptide Institute于1958年起源于大阪大学蛋白研究所，一直致力于多肽、糖化学及蛋白的研究领域。 Peptide Institute为用户提供以下高质量的产品：',
        'agent-index-sentence-3': '如果您对Peptide Institute的产品感兴趣，可以联系希施生物科技（上海）有限公司，我们将会提供快捷、优质的服务，以及高质量的产品！ ',
        'agent-index-sentence-4-title': '生物活性多肽和蛋白质',
        'agent-index-sentence-4-content': '● 酶抑制剂和底物\n● 碳水化合物和缀合物\n● 肽抗血清和单克隆抗体\n● 氨基酸和氨基酸衍生物\n● 肽合成试剂',
        'agent-index-sentence-5-title': '用于基础研究的定制合成',
        'agent-index-sentence-5-content': '● 肽和肽修饰的衍生物（磷酸化的肽，糖肽，荧光标记的肽等）\n● 表位肽，生物结合物和多克隆抗体的制备•糖脂，核苷酸糖，糖相关化合物等\n● 用于生物研究的其他有机化合物',
        'agent-index-sentence-6-title': '用于药物开发研究的定制合成',
        'agent-index-sentence-6-content': '● 药物\n● 药物中间体\n● 药物保护肽和氨基酸衍生物\n● 用于临床研究的GMP肽',
        'agent-index-sentence-7-title': '网站和联系方式',
        'agent-index-sentence-7-content': '● 肽研究所：www.peptide.co.jp/cn/\n● CSBio (Shanghai) Ltd：www.csbiochina.com\n● 地址：中国上海自由贸易试验区法拉第路85号2号楼502室，上海201210\n● 电子邮件：info@csbiochina.com',
        'agent-index-sentence-8-title': '中国大陆，香港，澳门地区销售经理',
        'agent-index-sentence-8-content': '● 陆叶手机：+86-13761860314\n● 电子邮件：joanna.lu@csbiochina.com\n● 毕蓝月手机：+86-13125840517\n● 电子邮件：lanyue_bi@csbiochina.com',
        'forgetPassTitle': '忘记密码？',
        'resetPass': '重置密码',
        'rtnLoginPage': '返回登入页',
        'NewsMgr': '最新消息管理',
        'showDate': '显示日期',
        'defaultImmediateShow': '预设立即显示',
        'ifShow': '是否显示',
        'defaultShow': '预设显示',
        'articleTitle': '文章标题',
        'articleNew': '新增文章',
        'articleEdit': '编辑文章',
        'newProdList': '新产品列表',
        'newProdMgr': '新产品管理',
        'releaseDate': '发布日期',
        'orderFailMsg': '订购失败，请洽客服客服人员。',
        'orderSuccess': '订购成功!!',
        'gotoOrderDetail': '前往订单详细资讯',
        'submit': '送出',
        'addToCart': '加入购物车',
        'year': '年',
        'month': '月',
        'yourCart': '你的购物车',
        'orderRecord': '订单相关纪录',
        'more': '更多',
        'career': '招聘',
        'ourhonor-sentence-1': '一種反相分離衍生化亮氨酸和異亮氨酸的方法',
        'ourhonor-sentence-2': '一種用於核酸DNA RNA生產型自動合成儀',
        'ourhonor-sentence-3': '希施生物曾獲20多種實用新型專利',
        'ourhonor-sentence-4': '中生藥協多肽分會理事單位',
        'ourhonor-sentence-5': '上海市生物醫藥行業協會會員單位',
        'ourhonor-sentence-6': '高新技術企業證書',
        'ourhonor-sentence-7': '2017微信年度企業',
        'antiBodyProdTitle': '抗体产品',
        'detail_name': '栏位',
        'detail_val': '值',
        'detail_new': "新增注释",
        'qtyPrice_name': '量',
        'qtyPrice_val': '价格',
        'qtyPrice_new': "新增品项",
    },
    'zh-TW': {
        'prodInfo': '產品資料',
        'prodName': '產品名稱',
        'prodId': '產品編號',
        'backendMgr': '後台管理',
        'rtnHome': '返回首頁',
        'prod': '產品',
        'order': '訂單',
        'prodMgr': '產品管理',
        'prodClassMgr': '產品類別管理',
        'orderMgr': '訂單管理',
        'rcverInfo': '收件人資訊',
        'rcverName': '收件人名稱',
        'rcverEmail': '收件人信箱',
        'rcverPhone': '收件人電話',
        'rcverAddr': '收件人地址',
        'addr': '地址',
        'zip': '郵遞區號',
        'buyerInfo': '購買人資訊',
        'name': '姓名',
        'email': '信箱',
        'phone': '電話',
        'orderId': '訂單編號',
        'orderStatus': '訂單狀態',
        'deliInfo': '運送資訊',
        'buyRecord': '購物記錄',
        'created_at': '創建時間',
        'totalPrice': '總價格',
        'subPrice': '小計',
        'notPaid': '尚未付款',
        'paid': '已付款',
        'newProdClass': '新增產品類別',
        'edProdClass': '編輯產品類別',
        'prodClass': '產品類別',
        'cancel': '取消',
        'confirm': '確定',
        'prodCategory': '產品種類',
        'item': '項目',
        'itemPrice': '項目價格',
        'checkout': '結帳',
        'commentField': '註釋欄位',
        'commentContent': '註釋內容',
        'comment': '註釋',
        'fileImport': '文件匯入',
        'uploadFile': '上傳文件',
        'uploadImg': '上傳圖片',
        'uploadFileSuccessMsg': '上傳成功，資料已經匯入完成',
        'reset': '重置',
        'all': '全部',
        'newProd': '新增產品',
        'prodImport': '匯入產品',
        'importRelatedFile': '匯入產品關聯檔案',
        'edit': '編輯',
        'new': '新增',
        'data': '資料',
        'downloadFiles': '檔案下載',
        'uploadRelatedProdFile': '上傳產品關聯檔案',
        'prodImg': '產品圖片',
        'filterItem': '過濾項目',
        'relatedFile': '關聯檔案',
        'operate': '操作',
        'limitedFile': '受限檔案',
        'inquiry': '詢價',
        'count': '數量',
        'newPass': '新密碼',
        'newPassConfirm': '新密碼確認',
        'confirmChange': '確定更改',
        'prodAndService': '公司產品和服務',
        'GMPProdPeptide': 'GMP生產多肽',
        'pepSyn': '多肽合成儀',
        'aboutUs-sentence-1': '希施生物科技（上海）有限公司擁有全球最完整和技術含量高的多肽產業的生產基地，其產品涵蓋了多肽合成、GMP生產多肽，客戶定制生產多肽、常用多肽、磷酸化多肽、多肽環化、多肽偶聯、多肽修飾。同時，圍繞著多肽產業，希施生物科技還形成了龐大的上、下游產品鏈，上游產品包括：各類多肽試劑，氨基酸、保護氨基酸、Fmoc-氨基酸、Boc-氨基酸、特殊氨基酸、縮合劑、固相樹脂-等產品；下游產品包括：抗體、單克隆抗體、定制生產多抗。經過20年多時間的發展，已經成為全球的主要多肽產業生產供應商之一。 ',
        'aboutUs-sentence-2': '希施生物科技擁有經FDA審核通過的GMP多肽生產基地，能提供全系列的GMP生產多肽和定制多肽！我們的目標就是要提供最高品質多肽產品給我們的客戶,並在規定的時間內符合客戶要求！我們的員工擁有高超多肽生產知識和技術水平，也非常熟知GMP的要求！我們品質部每年都會進行持續性的GMP培訓並做好培訓記錄。 <br>我們對品質的承諾和遵守的是我們公司運作的驅動力。我們歡迎老客戶和潛在的客戶來審核我們的GMP生產基地！假如你有任何關於我們的GMP生產多肽的問題，請隨時聯繫我們！ ',
        'aboutUs-sentence-3': '希施生物科技擁有20多年生產合成儀的經驗能提供不同型號的全自動多肽合成儀用於非GMP和GMP級別多肽生產！ ',
        'home-sentence-1': '我們的理念是客戶的利益至上，並向新型多肽企業邁進',
        'home-sentence-2': '我們的使命是提供最優質的產品和優秀的客戶服務',
        'home-sentence-3': '我們的願景是成為全球多肽解決方案提供商',
        'csbio': '希施',
        'home': '首頁',
        'prodList': '產品列表',
        'memCenter': '會員中心',
        'orderList': '訂單列表',
        'cart': '購物車',
        'logout': '登出',
        'memLogin': '會員登入',
        'bookName': '訂購人姓名',
        'bookPhone': '訂購人電話',
        'bookEmail': '訂購人信箱',
        'filter': '過濾器',
        'choice': '請選擇',
        'lastStep': '上一步',
        'createOrder': '建立訂單',
        'price': '單價',
        'cartEmpty': '購物車為空的',
        'nextStep': '下一步',
        'registerEmail': '註冊信箱',
        'pass': '密碼',
        'login': '登入',
        'register': '註冊',
        'forgetPass': '忘記密碼',
        'passConfirm': '密碼確認',
        'memInfo': '會員資料',
        'resendVerify': '重新發送驗證信',
        'changePass': '更變密碼',
        'waitPay': '等待付款',
        'send': '傳送',
        'rcvAddr': '收件地址',
        'aboutUs': '關於我們',
        'siteMap': '站點地圖',
        'ourHonor': '企業榮耀',
        'careers': '招聘',
        'news': '新聞',
        'contactUs': '聯繫我們',
        'latestNews': '最新消息',
        'introd': '產品介紹',
        'peptide': '多肽',
        'pepReag': '多肽試劑',
        'qulityCtrl': '品質管理',
        'pep-gmp-sentence-1': '希施生物科技擁有經FDA審核通過的GMP多肽生產基地，能提供全系列的GMP生產多肽和定制多肽！我們的目標就是要提供最高品質多肽產品給我們的客戶,並在規定的時間內符合客戶要求！我們的員工擁有高超多肽生產知識和技術水平，也非常熟知GMP的要求！我們品質部每年都會進行持續性的GMP培訓並做好培訓記錄。 \n\n我們對品質' +
            '的承諾和遵守的是我們公司運作的驅動力。我們歡迎老客戶和潛在的客戶來審核我們的GMP生產基地！假如你有任何關於我們的GMP生產多肽的問題，請隨時聯繫我們！ ',
        'pep-cus-sentence-1': '我們懂多肽',
        'pep-cus-sentence-2': '希施生物科技有多年曆史悠久和豐富的客戶定制多肽合成服務,多肽修飾以及多肽文庫的經驗。我們多肽基地生產過上萬種的多肽；從線性肽到非常複雜多肽包括不同類型的多肽修飾（請看我們的修飾列表），多肽訂量從微量毫克到公斤級，不一樣的純度（麤品到98%以上純度）按不同客戶應用要求例如抗體研究、功能分析尤其是新藥物開發等領域！在客戶下訂單之前，我們將為多肽用戶提供免費專業多肽技術諮詢已讓客戶對的多肽序列設計有更深入的了解和選擇空間！ \n\n身為希施的尊貴的客戶，我們會不辭餘力為你提供你多肽訂單的生產全過程信息到你收到多肽產品後，我們還是會不間斷和你保持聯繫已以確保你實驗能順利完成！ \n\n我們承諾客戶可靠的高品質，性價比高據有競爭力的價格價格和優越的客戶服務是客戶始終相信希施來完成他們的研發工作！ ',
        'pep-cus-sentence-3': '客戶定制生產多肽 2013價格 (non-GMP)',
        'pep-cus-sentence-4': '多肽修飾列表',
        'pep-cus-sentence-5': '如何訂購多肽\n\n● 我們報價是人民幣含稅價（利率換算：1US$：7.3人民幣）\n\n● 多肽價目表是以每個氨基酸殘基來計算法，例如：一條100毫克15個氨基酸殘基純度95%的多肽(不帶修飾) 15個（酸殘基) x$30.80 (單價) 100毫克，純度95% ) = US$462等於人民幣3372.60 \n\n● 每個批次的多肽產品都會附上質譜，液相色譜圖，自檢單等等品質文件。 \n\n● 我們也能提供多肽合成工藝圖\n\n● 關於多肽修飾的選擇，請參考我們的修飾列表！基本上我們都可以提供除非不能再國內找到的原料！我們也 接受客戶提供原料，我們不會收取任何額外的修飾！ \n\n● 生產週期：去鹽多肽一周以內，正常純化多肽2周可以完成\n\n● 我們會收取7元一管的多肽分包裝費用！ \n\n● 國內快遞發貨可以在2-3天到達客戶，費用是人民幣30元\n\n● 假如客戶需要低溫運輸，我們也能提供不過需要收取額外的費用！ \n\n● 我們承諾客戶多肽信息將受到保密，有需要我們非常樂意簽署保密協議！ \n\n● 您可以任選一種方式向希施生物科技(上海)有限公司定購多肽:\n\n— 郵件訂購：客戶發正式訂購多肽訂單到我們郵箱，多肽訂購郵箱peptideorder@csbiochina. com確認多肽定\n制訂單。我們將在24小時以內已郵件，傳真或電話確訂單認\n\n— 傳真訂購：客戶發正式訂購多肽訂單至我們公司傳真：021-50781661-8008您可以向我們的銷售工程師\n索取合同文件，填寫完整併蓋上有效的公章後傳真至021-。我們的客服人員會在半小時之內與您確認完\n成產品的訂購合同。 \n\n— 在線瀏覽訂購：您可以直接訪問希施生物科技（上海）有限公司企業網站的產品目錄頁面進行產品瀏\n覽，點擊您感興趣相關的產品鏈接，在產品詳細介紹頁面的下麵點擊訂購，輸入您的要求即可。我們在\n收到您的訂購信息後會與您聯繫\n\n— 在線搜索定購：您可以通過產品搜索功能搜索我們的產品，然後在相關的產品詳細介紹頁面的下麵點擊\n訂購，輸入您的要求即可。我們在收到您的訂購信息後會與您聯繫\n\n— 在線客戶定制：您也可以通過點擊客戶定制輸入您要求的產品資料，點擊提交進行定購。 \n\n— 電話訂購流程：您可以致電銷售電話021-50781660，告訴我們您需要的肽的序列，數量和純度。我們的\n銷售人員將在24小時內給您報價,並致電和您協商價格，包裝等內容，同時將內容製作成合同以傳真或者\n郵件的形式給您，待您確認合同內容確認後，我們會按合同給您安排生產發貨直至合同履行完畢\n\n需要更多信息請可以發郵件到info@csbiochina.com\n\n台灣希施生物科技股份有限公司\n地址：新竹縣竹北市嘉豐十一路一段100號6樓之6\n地址英文：6F.-6, No. 100, Sec. 1, Jiafeng 11th Rd., Zhubei City, Hsinchu County, Taiwan (R.O.C.)\n電話：03-6578668',
        'popularPeptide': '常規多肽',
        'pop-pep-sentence-1': '希施生物科技提供一系列非常全面常用多肽用於多肽研發。我們常用多肽產品都是預分包裝立即可以使用。我們針對這些常用多肽進行非常完整的品質檢測保證包括HPLC分析純度和質譜分析來確認多肽。請隨時諮詢我們公司網站或聯繫我們關於你所需要的多肽名稱，多肽序列或相關多肽研發類別。假如你沒有找到你所關注的多肽，我們可以按你的要求為你定制多肽。請電話聯絡我們 (電話：03-6578668)',
        'pep-cov19-sentence-1': 'SARS病毒是一種囊膜病毒，都是通過囊膜融合蛋白和細胞膜的受體結合而侵入細胞。利用競爭抑制病毒的原理，我們可以搶先佔據SARS病毒囊膜融合蛋白的融合位點，使之失去和人體細胞的融合位置。 SARS病毒全基因序列公佈後，我們可以查到幾段與其它囊膜病毒融合蛋白類似的氨基酸序列。如同其它囊膜病毒融合蛋白的氨基酸序列，這兩段氨基酸序列也有“保守”的特點，不同的變種差異也不會太大。我們可以通過合成這兩段氨基酸序列製成多肽藥物，利用其可以搶先結合病毒融合蛋白本身融合位點，從而阻斷病毒的感染途徑。而我們可以了解到SARS的病理特徵與COVID-19和MERS感染者的病理特徵極其相似，而且三種疾病的致病病毒都屬於β冠狀病毒屬，所以我們可以考慮利用相同的原理利用多肽藥物把病毒阻止在細胞之外。 \n\n希施生物致力於為全球科研單位提供新冠病毒(SARS&MERS&COVID-19)研究級多肽，以豐富的經驗設計了多種新冠病毒相關多肽為客戶提供全方位多肽解決。 ',
        'pep-cov19-sentence-2': '希施簡介',
        'pep-cov19-sentence-3': 'CSBio是一家成立27年的全方位多肽公司，可提供3大類產品：\n1)多肽CDMO & CMO服務－GMP和研發多肽生產，有USFDA認證API多肽生產資質\n2)多肽研發和生產設備－從研發到生產型合成儀，裂解儀，純化製備，裝柱機，多肽實驗室和生產車間技術支持\n3) 多肽重要原料－ 保護標準和高品質氨基酸和多肽試劑，有相關驗證數據，穩定性數據和DMF技術文件支持.我們基本上是一家多肽全方位產品和服務公司。 \n4）寡核苷酸合成儀-可用於研發、工藝開發和生產。 ',
        'pep-cov19-sentence-4': '台灣希施生物科技股份有限公司',
        'pep-cov19-sentence-5': '地址：新竹縣竹北市嘉豐十一路一段100號6樓之6\n地址英文：6F.-6, No. 100, Sec. 1, Jiafeng 11th Rd., Zhubei City, Hsinchu County, Taiwan (R.O.C.)\n電話：03-6578668',
        'pep-pet-sentence-1': '現代醫學診斷學研究中，分子成像技術（正電子發射斷層顯像）日趨重要，因為它不但具有較高的專一性，而且能給研究者提供分子水平的生物學信息。多肽分子經標記後成為一類分子探針，可應用於分子成像技術以滿足各種藥理學研究（例如：疾病的早期診斷、疾病發展的潛在生化過程的實時可視化以及疾病治療整個過程的跟踪） 。 ',
        'cusManuPep': '客戶定制生產多肽',
        'petPepAndPretty': 'PET多肽和美容肽',
        'cov19Introd': '新冠病毒相關介紹',
        'aminoAcidsResins': '氨基酸和樹脂',
        'pepReag-AAR-sentence-1': '點擊查看我們的多肽試劑\n\n希施生物科技擁有全球最完整和技術含量高的多肽相試劑，還形成了龐大的上、下游產品鏈，上游產品包括：各類氨基酸和固相樹脂-等產品；經歷20年多時間的發展，已經成為全球的主要多肽產業生產供應商之一。 \n\n希施生物科技經過二十多年的發展，已經成為全球的主要多肽產業生產供應商之一。 \n\n● 各類氨基酸和相關衍生物\n● 各類氨基酸和相關衍生物氨基醇\n● Boc-氨基酸和相關衍生物\n● Fmoc-氨基酸和相關衍生物\n● 鏈接劑\ n● N甲基-氨基酸和相關衍生物\n● N端保護劑\n● 其他常用多肽試劑\n● 多肽縮合劑\n● 特殊氨基酸\n● 特殊樹脂\n● Z-氨基酸和相關衍生物\n請隨時詢問我們假如你找不到想要的氨基酸和樹脂！我們會盡快回复庫存量和價格',
        'aminoAcidsCartridges': '氨基酸試劑盒',
        'pepReag-AAC-sentence-1': '希施生物科技擁有全球最完整和技術含量高的氨基酸試劑盒用於我們的多款多肽合成儀！讓你在使用我們的合成儀時沒有後顧之憂！請隨時詢問我們假如你找不想要的氨基酸和樹脂！我們會盡快回复庫存量和價格',
        'fineChemicals': '精細化工',
        'pepReag-FC-sentence-1': '希施生物科技向國際化工用戶提供特別針對國內和亞洲化工品的對外包服務。我們的強大供應管理團隊能和供應商協力確保產品品質。我們品質部能對供應商進行系統品質審核和產品品質確認。請隨時和我們洽談！ ',
        'reagForDnaRnaSyn': 'DNA/RNA合成儀配套試劑',
        'pepReag-RFDRS-sentence-1': '希施簡介',
        'pepReag-RFDRS-sentence-2': 'CSBio是一家成立27年的全方位多肽公司，可提供3大類產品：\n1)多肽CDMO & CMO服務－GMP和研發多肽生產，有USFDA認證API多肽生產資質\n2)多肽研發和生產設備－從研發到生產型合成儀，裂解儀，純化製備，裝柱機，多肽實驗室和生產車間技術支持\n3) 多肽重要原料－ 保護標準和高品質氨基酸和多肽試劑，有相關驗證數據，穩定性數據和DMF技術文件支持.我們基本上是一家多肽全方位產品和服務公司。 \n4）寡核苷酸合成儀-可用於研發、工藝開發和生產。 ',
        'pepReag-RFDRS-sentence-3': '台灣希施生物科技股份有限公司',
        'pepReag-RFDRS-sentence-4': '台灣希施生物科技股份有限公司\n地址：新竹縣竹北市嘉豐十一路一段100號6樓之6\n地址英文：6F.-6, No. 100, Sec. 1, Jiafeng 11th Rd., Zhubei City, Hsinchu County, Taiwan (R.O.C.)\n電話：03-6578668',
        'qualAss': '品質保證',
        'qualAss-qualAss-sentence-1': '希施生物科技以品質做為管理宗旨和企業文化。確保客戶滿意是我們為每位客戶提供的承諾！我們的員工均經過專業的品質培訓，理解品質對於客戶的重要程度，嚴格貫徹執行品質標準！我們的產品在發貨前都經過嚴格檢測和驗證，以確保客戶收到的產品無後顧之憂。每批產品均附有詳細的質檢單，分析條件，分析數據，穩定性數據等一系列詳細數據。我們也會和供貨商合作，以確保供貨商提供的原料符合我們的品質要求！ \n\n在產品品質控制中，我們採用以下技術：',
        'qualAss-qualAss-sentence-2': '除了以上品質體系，我們也盡力提供以下文件來支持客戶GMP要求！ ',
        'qualAss-qualAss-orderlist1-item1': '純度(高效液相色譜儀)',
        'qualAss-qualAss-orderlist1-item2': '薄層色譜法',
        'qualAss-qualAss-orderlist1-item3': '電噴霧質譜',
        'qualAss-qualAss-orderlist1-item4': '核磁共振',
        'qualAss-qualAss-orderlist1-item5': '手性高效液相',
        'qualAss-qualAss-orderlist1-item6': '離子色譜',
        'qualAss-qualAss-orderlist1-item7': '比旋光度',
        'qualAss-qualAss-orderlist1-item8': '卡爾費休滴定',
        'qualAss-qualAss-orderlist1-item9': '酸鹼滴定法',
        'qualAss-qualAss-orderlist1-item10': '紫外-可見光光譜分析',
        'qualAss-qualAss-orderlist1-item11': '金屬夾雜物分析',
        'qualAss-qualAss-orderlist1-item12': '元素分析',
        'qualAss-qualAss-orderlist1-item13': '氨基酸分析',
        'qualAss-qualAss-orderlist2-item1': '供應商聲明問卷',
        'qualAss-qualAss-orderlist2-item2': '來源證明',
        'qualAss-qualAss-orderlist2-item3': '非轉基因聲明',
        'qualAss-qualAss-orderlist2-item4': '產品合成路線',
        'qualAss-qualAss-orderlist2-item5': '三聚氰胺申報',
        'qualAss-qualAss-orderlist2-item6': '變更申明',
        'qualAss-qualAss-orderlist2-item7': '潛在雜質列表',
        'qualAss-qualAss-orderlist2-item8': '1類溶劑，滿足監管要求',
        'qualAss-qualAss-orderlist2-item9': '儀表清單',
        'qualAss-qualAss-orderlist2-item10': '溶劑和催化劑清單',
        'qualAss-qualAss-orderlist2-item11': '材料安全數據表',
        'csbioAnalyServices': '希施分析服務',
        'qualAss-CAS-sentence-1': 'CSBio 高可信度的品質，並且我們提供合格的產品給我們全世界的客戶。因此我們有齊全的品管實驗室以及必要的狀態分析儀器。我們也提供分析測試服務給想外包來檢測產品品質的客戶。 ',
        'qualAss-CAS-orderlist-title1': '質譜分析',
        'qualAss-CAS-orderlist-1-1': '電噴霧-質譜',
        'qualAss-CAS-orderlist-1-2': '液相色譜 質譜聯用',
        'qualAss-CAS-orderlist-1-3': '液相二級質譜，是將經過第一次質譜檢測的離子以某種方式碎裂後再進行質譜檢測',
        'qualAss-CAS-orderlist-title2': '液相分析',
        'qualAss-CAS-orderlist-2-1': '反相高效液相色譜分析法',
        'qualAss-CAS-orderlist-2-2': '高效體積排阻色譜法',
        'qualAss-CAS-orderlist-2-3': '離子液相',
        'qualAss-CAS-orderlist-2-4': '針對非藥品生產品質管理規范范項目的方法開發和驗證',
        'qualAss-CAS-orderlist-title3': '核磁共振分析',
        'qualAss-CAS-orderlist-title4': '紅外分析服務',
        'qualAss-CAS-orderlist-title5': '手性液相分析服務',
        'qualAss-CAS-orderlist-title6': '氨基酸分析服務',
        'qualAss-CAS-orderlist-6-1': '蛋白、多肽經鹽酸水解釋放氨基酸殘基後能被柱前衍生化反相高效液相色譜分析法',
        'qualAss-CAS-orderlist-title7': '水分測試',
        'qualAss-CAS-orderlist-7-1': '卡爾-費休滴定分析水分',
        'qualAss-CAS-orderlist-title8': '肽含量',
        'qualAss-CAS-orderlist-8-1': '元素分析',
        'qualAss-CAS-orderlist-title9': '肽抗衡離子含量',
        'qualAss-CAS-orderlist-9-1': '用離子液相來測三氟乙酸,冰醋酸含量',
        'qualAss-CAS-orderlist-title10': '殘留溶劑含量',
        'qualAss-CAS-orderlist-10-1': '氣相色譜N,N-二甲基甲酰胺，甲醇，乙腈',
        'qualAss-CAS-orderlist-title11': '熔點',
        'qualAss-CAS-orderlist-title12': '元素分析',
        'qualAss-CAS-orderlist-12-1': '分析有機化工品的碳，氫，氮等等含量',
        'qualAss-CAS-orderlist-title13': '多肽分析測試',
        'qualAss-CAS-orderlist-title14': '多肽類產品凍乾服務',
        'preHplcAndCol': '製備液相\n系統',
        'phac-phhs-sentence-1': '希施生物為用戶提供不同規模的高壓液相製備系統和色譜柱。我們提供的製備液相繫統可用於發酵類藥物﹑天然產物類原料藥﹑多肽類藥物﹑醫藥中間體和化工中間體的製備分離。 ',
        'phac-phhs-sentence-2': '希施生物添加純化設備到我們的自動化肽合成儀產品系列，使我們能夠提供從多肽合成到最終純化的完整服務和設備。 ',
        'semiPrepHplcSys': '半製備液相\n系統',
        'phac-sphs-sentence-1': 'GL6000系列25ml-250ml最大流量泵頭，SAC & DAC 25.4mm-100mm半製備色譜柱。 ',
        'phac-sphs-sentence-2': '系統配置',
        'pilotPreHplcSys': '中試製備型\n液相繫統',
        'phac-pphs-sentenct-1': 'GL6000系列 500ml-1L最大流量泵頭，DAC100mm-200mm製備色譜柱',
        'phac-pphs-sentenct-2': '系統配置',
        'indusPrepHplcSys': '工業製備型DAC\n液相繫統',
        'phac-iphs-sentenct-1': '● GL6000系列 2L-20L最大流量泵頭，DAC200mm-800mm製備色譜柱\n● 防爆隔膜泵\n● 系統硬件和軟件支持GMP/21CRF11，3Q。 ',
        'phac-iphs-sentenct-2': '工業製備型DAC液相繫統',
        'csbioProdListTitle-1': 'CSBio',
        'csbioProdListTitle-2': '產品列表',
        'instru-ncsbio-title-1': '希施生物新品發布：CSBio II 研發級多肽合成儀',
        'instru-ncsbio-content-1': 'CSBio II是一款全自動多肽合成儀，用於合成50mg至500mg規模多肽。 \n\n這是一款市場上最經濟的研髮型多肽合成儀，CSBio II多肽合成儀的設計對於沒有合成經驗的用戶也很容易操作，使用人員在實驗室就可以很容易的合成多肽。 ',
        'instru-ncsbio-title-2': 'CSBio II 合成儀',
        'instru-cs136-sentence-1': 'CS136系列是以研發級多肽合成儀為特點的，這系列合成儀可用於研發，工藝開發和小規模生產。 CS136系列合成儀的反應瓶尺寸從10ml至250ml，該型號合成儀使用180度翻轉混合方式來達到樹脂和溶劑的充分接觸。 CS136系列合成儀還提供在線紫外監測作為選配項並用於脫保護過程的監測，同時該系列合成儀還有加熱裝置選配項可用於合成過程中的關鍵的洗滌，縮合和脫保護循環。 ',
        'instru-cs136-sentence-2': 'CS136M這款合成儀是基於廣受歡迎的CS136X平台，該平台具有靈活多肽合成的最強大技術，並能為高通量用戶提供同時合成6條多肽的能力。 \n\nCS136M用於研發大批量小規模多肽生產。該型號合成儀可以使用尺寸範圍20ml至100ml的反應瓶並採用我們180度翻轉專利技術，可以實現溶劑和樹脂的充分接觸，CS136M可根據客戶要求進行定制。標準選項包括用於加熱控制的夾套反應器，自動軟件集成的加熱循環水浴，紫外監控和方便使用的觸屏電腦系統。 ',
        'instru-cs536-sentence-1': 'CS536被設計用於中試規模，使用單通道批生產，這款合成儀被廣泛用於工藝開發和放大開發。 CS536合成儀的合成規模要大於CS136系列，CS536也可以使用180度翻轉攪拌或者頂置攪拌方式。 ',
        'instru-cs936-sentence-1': 'CS936系列合成儀是CS Bio公司大規模生產型系統，包括CS936S,CS936和CS936X。最小規模的CS936S反應釜尺寸從500ml到5L，而CS936X的反應釜尺寸最大，從50L到1000L。這些生產型系統是世界上最大的而且最有效的自動多肽合成儀。 ',
        'instru-drs-sentence-1': '來自CSBio的CS-OLIGO-D是一種全自動DNA / RNA寡核苷酸合成儀，可用於研發，工藝開發和生產。 \n\n這套系統配備180度翻轉攪拌反應瓶，沖洗以及反應瓶再循環等功能。這些功能允許大批量樹脂溶脹，通過DNA合成的傳統沖洗和用於RNA合成的再循環功能。 ',
        'home-about-our-company': '台灣希施股份有限公司',
        'home-content-1': 'GMP多肽',
        'home-content-2': '分析服務',
        'home-content-3': '創新公司',
        'home-content-4': '多肽合成儀',
        'home-content-5': '多肽試劑',
        'home-content-6': '代理多肽',
        'pageMgr': '頁面管理',
        'carouselMgr': '輪播管理',
        'deleteConfirm': '確定要刪除!?',
        'agent': '代理',
        'agent-index-sentence-1': '多肽研究所',
        'agent-index-sentence-2': '台灣希施生物科技股份有限公司非常榮幸的向國內廣大高端生物科技用戶宣布：從2015年7月開始，我們正式成為日本Peptide Institute在台灣的唯一代理商。 \nPeptide Institute於1958年起源於大阪大學蛋白研究所，一直致力於多肽、糖化學及蛋白的研究領域。 Peptide Institute為用戶提供以下高品質的產品：',
        'agent-index-sentence-3': '如果您對Peptide Institute的產品感興趣，可以聯繫台灣希施生物科技股份有限公司，我們將會提供快捷、優質的服務，以及高品質的產品！ ',
        'agent-index-sentence-4-title': '生物活性多肽和蛋白質',
        'agent-index-sentence-4-content': '● 酶抑製劑和底物\n● 碳水化合物和綴合物\n● 肽抗血清和單克隆抗體\n● 氨基酸和氨基酸衍生物\n●肽合成試劑',
        'agent-index-sentence-5-title': '用於基礎研究的定制合成',
        'agent-index-sentence-5-content': '● 肽和肽修飾的衍生物（磷酸化的肽，糖肽，熒光標記的肽等）\n● 表位肽，生物結合物和多克隆抗體的製備•醣脂，核苷酸糖，糖相關化合物等\n● 用於生物研究的其他有機化合物',
        'agent-index-sentence-6-title': '用於藥物開發研究的定制合成',
        'agent-index-sentence-6-content': '● 藥物\n● 藥物中間體\n● 藥物保護肽和氨基酸衍生物\n● 用於臨床研究的GMP肽',
        'agent-index-sentence-7-title': '網站和聯繫方式',
        'agent-index-sentence-7-content': '● 肽研究所：www.peptide.co.jp/cn/\n● CSBio (Taiwan) Ltd：www.csbiotaiwan.com\n● 地址：新竹縣竹北市嘉豐十一路一段100號6樓之6\n● 電話：03-6578668',
        'agent-index-sentence-8-title': '中國大陸，香港，澳門地區銷售經理',
        'agent-index-sentence-8-content': '● 地址：新竹縣竹北市嘉豐十一路一段100號6樓之6\n● 地址英文：6F.-6, No. 100, Sec. 1, Jiafeng 11th Rd., Zhubei City, Hsinchu County, Taiwan (R.O.C.)\n● 電話：03-6578668',
        'forgetPassTitle': '忘記密碼？ ',
        'resetPass': '重置密碼',
        'rtnLoginPage': '返回登入頁',
        'NewsMgr': '最新消息管理',
        'showDate': '顯示日期',
        'defaultImmediateShow': '預設立即顯示',
        'ifShow': '是否顯示',
        'defaultShow': '預設顯示',
        'articleTitle': '文章標題',
        'articleNew': '新增文章',
        'articleEdit': '編輯文章',
        'newProdList': '新產品列表',
        'newProdMgr': '新產品管理',
        'releaseDate': '發布日期',
        'orderFailMsg': '訂購失敗，請洽客服客服人員。 ',
        'orderSuccess': '訂購成功!!',
        'gotoOrderDetail': '前往訂單詳細資訊',
        'submit': '送出',
        'addToCart': '加入購物車',
        'year': '年',
        'month': '月',
        'yourCart': '你的購物車',
        'orderRecord': '訂單相關紀錄',
        'more': '更多',
        'career': '招聘',
        'ourhonor-sentence-1': '一种反相分离衍生化亮氨酸和异亮氨酸的方法',
        'ourhonor-sentence-2': '一种用于核酸DNA RNA生产型自动合成仪',
        'ourhonor-sentence-3': '希施生物曾获20多种实用新型专利',
        'ourhonor-sentence-4': '中生药协多肽分会理事单位',
        'ourhonor-sentence-5': '上海市生物医药行业协会会员单位',
        'ourhonor-sentence-6': '高新技术企业证书',
        'ourhonor-sentence-7': '2017微信年度企业',
        'antiBodyProdTitle': '抗體產品',
        'detail_name': '欄位',
        'detail_val': '值',
        'detail_new': "新增註釋",
        'qtyPrice_name': '量',
        'qtyPrice_val': '價格',
        'qtyPrice_new': "新增品項",
    },
    'en': {
        'prodInfo': 'More',
        'prodName': 'Product Name',
        'prodId': 'Product Id',
        'backendMgr': 'Admin Dashboard',
        'rtnHome': 'Return Home',
        'prod': 'Product',
        'order': 'Order',
        'prodMgr': 'Product Management',
        'prodClassMgr': 'Product Catgory Management',
        'orderMgr': 'Order Management',
        'rcverInfo': 'Receiver Info',
        'rcverName': 'Receiver Name',
        'rcverEmail': 'Receiver Email',
        'rcverPhone': 'Receiver phone',
        'rcverAddr': 'Receiver Address',
        'addr': 'Address',
        'zip': 'Zip',
        'buyerInfo': 'Buyer Info',
        'name': 'Name',
        'email': 'Email',
        'phone': 'Phone',
        'orderId': 'Order Id',
        'orderStatus': 'Order Status',
        'deliInfo': 'Shipping Info',
        'buyRecord': 'Shopping Record',
        'created_at': 'Create Time',
        'totalPrice': 'Total Price',
        'subPrice': 'Sub Price',
        'notPaid': 'Not paid yet',
        'paid': 'Paid',
        'newProdClass': 'Create Product Category',
        'edProdClass': 'Edit Product Category',
        'prodClass': 'Product Category',
        'cancel': 'Cancel',
        'confirm': 'Confirm',
        'prodCategory': 'Product Category',
        'item': 'Item',
        'itemPrice': 'Item Price',
        'checkout': 'Checkout',
        'commentField': 'Comment Field',
        'commentContent': 'Comment Content',
        'comment': 'Comment',
        'fileImport': 'File Import',
        'uploadFile': 'Upload File',
        'uploadImg': 'Upload Image',
        'uploadFileSuccessMsg': 'Upload Success. Data have imported.',
        'reset': 'Reset',
        'all': 'All',
        'newProd': 'Create Product',
        'prodImport': 'Product Import',
        'importRelatedFile': 'Product Related Import',
        'edit': 'Edit',
        'new': 'Create',
        'data': 'Data',
        'downloadFiles': 'Download File',
        'uploadRelatedProdFile': 'Upload Product Related File',
        'prodImg': 'Product Image',
        'filterItem': 'Filter Item',
        'relatedFile': 'Related File',
        'operate': 'Operate',
        'limitedFile': 'Limited File',
        'inquiry': 'Inquiry',
        'count': 'Count',
        'newPass': 'New Password',
        'newPassConfirm': 'New Password Confirm',
        'confirmChange': 'Change',
        'prodAndService': 'Product And Service',
        'GMPProdPeptide': 'GMP peptide\nproduction',
        'pepSyn': 'Instrumentation',
        'aboutUs-sentence-1': 'CSBio (Shanghai) Ltd is part of the global expansion plan for CSBio California- based US biotechnology which has brought over 20 years’experience serving the life science community in the arena of peptide synthesizers and custom peptides! We feel our biggest asset is our stellar reputation in the biotechnology field in both peptide production and peptide synthesizers as well as our good standing in the local and biotech communities. CSBio is the only GMP certified peptide synthesizers manufacturer in the world. CSBio also has a full scale, FDA inspected peptide production laboratory and holds a Drug Manufacturing License from the state of California. Situated within medicon valley of Zhangjiang Hitech Park, with R&D and production facilities in China and USA, CSBio China will extend her services to peptide synthesizers, peptide reagents, GMP manufactured peptides, custom manufactured peptides, antibody, and more than ten of thousands of peptide related products! Our Mission is to provide the best service to our customers in terms of high quality products and good customer service at a competitive pricing. Our vision is to become a global provider of peptide based new drug!',
        'aboutUs-sentence-2': 'CSBio features a full service FDA inspected GMP peptideproduction facility with a primary focus on custom and GMP peptide production.Our goal is to provide our customers with the highest quality compoundsavailable, in a time frame that matches customer requirements. Our staff ishighly skilled and has extensive training in both peptide chemistry and CurrentGood Manufacturing Practices. Ongoing training in cGMPs is conducted throughoutthe year and documented by our Quality Assurance department. Our commitment to quality and compliance is a driving force behind our operations. We welcome allcurrent and prospective customers to conduct audits and inspections of our cGMPfacilities and systems. Should you have any questions regarding C S Bio’ssynthetic cGMP operations, please do not hesitate to contact us.',
        'aboutUs-sentence-3': 'With 20 years of experience in the manufacturing of peptide synthesizers, CSBio canprovide various type of automated Peptide synthesizer in the production ofnon-GMP and GMP peptide.',
        'home-sentence-1': 'Our Philosophy is the customers’ interests always come first,and strive for global recognition by our customers and industry.',
        'home-sentence-2': 'Our Mission is to provide highest quality products and excellent customer service at a competitive pricing.',
        'home-sentence-3': 'Our vision is to become a global Total Peptide Solution Provider.',
        'csbio': 'CsBio',
        'home': 'Home',
        'prodList': 'Product List',
        'memCenter': 'User Info',
        'orderList': 'OrderList',
        'cart': 'Cart',
        'logout': 'Logout',
        'memLogin': 'Sign In',
        'bookName': 'Book Name',
        'bookPhone': 'Book Phone',
        'bookEmail': 'Book Email',
        'filter': 'Filter',
        'choice': 'Choose',
        'lastStep': 'Previous Step',
        'createOrder': 'Create Order',
        'price': 'Price',
        'cartEmpty': 'Cart is Empty',
        'nextStep': 'Next Step',
        'registerEmail': 'Register Email',
        'pass': 'Passwd',
        'login': 'Sign In',
        'register': 'Sign up',
        'forgetPass': 'Forget Password',
        'passConfirm': 'Passwd Confirm',
        'memInfo': 'User Info',
        'resendVerify': 'Resend Email Verify',
        'changePass': 'Change Password',
        'waitPay': 'Wait For Pay',
        'send': 'Send',
        'rcvAddr': 'Receiver Address',
        'aboutUs': 'About Us',
        'siteMap': 'Site map',
        'ourHonor': 'District Honor',
        'careers': 'Careers',
        'news': 'News',
        'contactUs': 'Contact Us',
        'latestNews': 'Latest News',
        'introd': 'Product Introduction',
        'peptide': 'Peptide',
        'pepReag': 'Peptide Reagent',
        'qulityCtrl': 'Quality Management',
        'pep-gmp-sentence-1': 'CSBio features a full service FDA inspected GMP peptide production facility with a primary focus on custom and GMP peptide production.Our goal is to provide our customers with the highest quality compoundsavailable, in a time frame that matches customer requirements. Our staff ishighly skilled and has extensive training in both peptide chemistry and CurrentGood Manufacturing Practices. Ongoing training in cGMPs is conducted throughoutthe year and documented by our Quality Assurance department. Our commitment toquality and compliance is a driving force behind our operations. We welcome allcurrent and prospective customers to conduct audits and inspections of our cGMP facilities and systems. Should you have any questions regarding CSBio’ssynthetic cGMP operations, please do not hesitate to contact us',
        'pep-cus-sentence-1': 'PEOPLE WHO KNOW PEPTIDE!',
        'pep-cus-sentence-2': 'CSBio has a long history and extensive experience incustom manufactured peptides service，peptide modification and peptide library since 1993 . We have produced more than tens of thousands ofpeptides at our peptide facility ranging from linear peptides to complicate dpeptides with different peptide modifications (please review our peptide modification list)  in various quantities (milligrams up to kilograms scales) in different purities (crude to 98% and above) as per customers’ application requirements infield of antibody research, functional analysis and especially new drug research and development. We will provide free pre-order professional technical consultation for those peptide users who need more in-depth background with their peptide sequence design before ordering. As our premium customers, we will continue to keep intouch with you through out the whole ordering process even after the order is delivered to you to ensure success in your research work. Our commitment to customers in reliably high quality, cost-effective competitive pricing and excellent customer service has been the reasons why customers have entrusted CSBio with their research work.',
        'pep-cus-sentence-3': 'Custom Manufactured Peptide Pricing List 2013 (non GMP)',
        'pep-cus-sentence-4': 'CSBIO Peptide Modification List',
        'pep-cus-sentence-5': 'Information in ordering peptides with CSBio\n\n● All pricing mentioned is in US Dollars unless stated otherwise.\n\n● Above chart is price of per amino acid residue for most standard peptides (unmodified). For example, 100mg 15 amino acid residue with purity of 95% is calculated as follows: 15 (amino acid residue) x$30.80 (pricing per amino acid at 100mg and 95% purity) = $462.\n\n● Mass spectrum and Certificate of Analysis are included every batch of each peptide\n\n● We can also provide route of synthesis upon request.\n\n● We can provide various modification (please see modification list) as long as we can get hold the raw material domestically. Customer might wish to consign us the modification raw material and we WILL NOT CHARGE any additional modification cost.\n\n● Manufacturing lead-time: within 1 week for desalted peptides, and 2 weeks for purified peptides for normal sequence and length.\n\n● Aliquot into additional vials will be charged an additional USD 1 per vial.\n\n● Courier Service (Door-To-Door: FEDEX/DHL/TNT/EMS) lead-time: 4 days. The courier service fee is USD 60 for shipment under 1kg with standard packing. Additional shipment fee will be required for bulk packaging.\n\n● Product will be declared as ‘Peptide’ for normal custom clearance unless full value and original name declaration is required at destination. Additional USD 75 will be charged for original name declaration.\n\n● Low temperature delivery is available on special request. This is an additional cost.\n\n● Non- Disclosure Agreement (NDA) will be signed upon request by customer to important information.\n\n● You can order with us through many different ways: issuing official purchase order through email or fax, on-line purchase or email confirmation at peptideorder@csbiochina.com. We will response through email, fax or telephone for order acceptance within 24 hours from time of order\n\nFor more information, please send us your request to email: info@csbiochina.com or fax: 0086-21-50781661 Ext 8008\n\nOur bank account (wire transfer):\n\nTo: CHINA CONSTRUCTION BANK CORPORATION SHANGHAI BRANCH (ZHANGJIANG SUB-BRANCH)\n\nSwift code: PCBCCNBJSHX\n\nNo.220 KE YUAN ROAD SHANGHAI CHINA 201204\n\nAccount Name: CSBio (Shanghai) Ltd.\n\nA / C No: 31014007000220009567',
        'popularPeptide': 'Catalog Peptide',
        'pop-pep-sentence-1': 'CSBio offers a complete line of popular peptides for research and development. These peptides are offered in various prepackaged quantities and ready for use. All of these peptide come with a complete quality control package including HPLC analysis to ensure purity and mass spectral analysis to confirm identity. Please feel free to search our catalog for any peptide by areas of research, sequence or the common peptide name. If you cannot find the peptide you are looking for please do not hesitate to contact us for assistance and/or a custom peptide quotation at info@csbiochina.com or visit us at : https://www.csbio.com/shop-peptides',
        'pep-cov19-sentence-1': 'SARS, an enveloped RNA virus, surface proteinin the form of ligand and cell surface receptor binding after the infectedcells. Using the competitive inhibition theory, we can design peptides to bindthe fusion point of SARS virus to inhibit viral attachment to the cellreceptor. After the whole gene sequence of SARS virus published, we can findthe sequences of several peptides like other enveloped viruses. These peptideshave been synthesized as drugs to prevent viral infection. MERS and COVID-19,member of the coronaviridae as same as SARS, are enveloped RNA virus. We candesign peptide drugs to stop the virus from attaching to cells.\n\nCSBioprovides SARS&MERS& CoVID-19 research-grade peptides to clientsworldwide. CSBio team has rich experience in designing multiple novelCoronavirus related peptides. To provide customers with a full range of peptidesolutions.',
        'pep-cov19-sentence-2': 'CSBio Introduction',
        'pep-cov19-sentence-3': 'CSBio is Global peptide company bringing more than 27 years of technical expertise into the peptide industry which cover three main categories of products and services:\n(1) peptide CDMO & CMO service -GMP and R&D peptide production, with API peptide production approved by USFDA.\n(2) Peptide Instrumentation - from R&D up to Large Scale Manufacturing-type synthesizer, Cleavage systems, PreHPLC system, Column packing equipment and peptide production technical support.\n(3) Peptide raw material -- High Quality Standard Grade and High Grade Fmoc-protected Amino Acid, peptide reagents, coupling reagents, resins and special reagents, supported by relevant validated QC data, stability data and DMF technical documents.\n(4) DNA/RNA oligonucleotide synthesizers that can be used from research、process development and production.',
        'pep-cov19-sentence-4': 'CSBio (Shanghai) Ltd.',
        'pep-cov19-sentence-5': 'China (Shanghai) Pilot Free Trade Zone, 85 Faladi Road, Building 2,Room 502 ,Shanghai 201210, China\nEmail:info@csbiochina.com\nTel:+8621-50781653/50781655\nFax:+8621-50781652/021-50781656\nWebsite: www.csbiochina.com www.csbio.com',
        'pep-pet-sentence-1': 'In the study of modern medical diagnostics, Molecular imaging in the form of positron emission tomography (PET) is becoming more and more important, because it not only has high specificity, dynamic imaging capabilities but also provides molecular biological information to researchers. Peptide are labeled as a class of molecular probes that can be applied to molecular imaging techniques to meet various pharmacological studies (such as early diagnosis of disease, real time visualization of underlying biochemical processes of disease development, and tracking of the whole process of disease treatment). Targeted probes made up of bifunctional reagents linked both peptides and chelate metallic elements can be used in molecular imaging techniques for cancer therapy. Multiple quantitative reagents for proteomics can be prepared by labeling various metallic elements in the presence of bifunctional reagents, and used in screening, identification and classification of tumor markers. Therefore, bifunctional reagents and peptides containing bifunctional reagents (PET peptides) have good application prospects in tumor research, CSBio is a professional peptide company expertise in providing many kinds of bifunctional reagents and PET peptides.',
        'cusManuPep': 'Custom Manufactured\nPeptides',
        'petPepAndPretty': 'PET And Cosmetic\nPeptide',
        'cov19Introd': 'COVID-19\nIntroduction',
        'aminoAcidsResins': 'Amino acids\nand Resins',
        'pepReag-AAR-sentence-1': 'CSBio offers a complete line of high quality peptide related reagents, protected amino acids and starting resins that will need your vast requirement for chemical and peptide synthesis. For the past 20 years, we have been one of the most important Peptide suppliers in the globe!\n\n● Amino Acids and Derivatives\n● Amino Alcohols\n● Boc-Amino Acids and Derivatives\n● Fmoc-Amino Acids and Derivatives\n● Linkers for Peptide Synthesis\n● N-Methyl Amino Acids and Derivatives\n● N-Protecting Reagents\n● Other Common Peptide Reagents\n● Peptide Coupling Reagents\n● Special Amino Acids\n● Special Resins\n● Z-Amino Acids and Derivatives\nShould you require an amino acid or resin that is not listed here, please contact us for pricing and availability.',
        'aminoAcidsCartridges': 'Amino acid\ncartridges',
        'pepReag-AAC-sentence-1': 'CSBio offers a complete line of high quality AminoAcid Cartridges coupled to our full range peptidesynthesizer making you hassle free while using our peptide synthesizer. Shouldyou require an amino acid cartridge that is not listed here, please contact usfor pricing and availability',
        'fineChemicals': 'Fine Chemicals',
        'pepReag-FC-sentence-1': 'CSBio is able to provide outsourcing services to customers who required finechemicals from China or other parts of Asia. Our strong and competitive supplymanagement team will work closely with the supplier to ensure products willmeet the quality requirement. We have our in-house quality team to verify thesupplier quality system and product quality. Please do not hesitate to contactus for such outsourcing services.',
        'reagForDnaRnaSyn': 'Reagent for DNA/RNA\nSynthesizer',
        'pepReag-RFDRS-sentence-1': 'CSBio Introduction',
        'pepReag-RFDRS-sentence-2': 'CSBio is Global peptide company bringing more than 26 years of technical expertise into the peptide industry which cover three main categories of products and services:\n(1) peptide CDMO & CMO service -GMP and R&D peptide production, with API peptide production approved by USFDA.\n(2) Peptide Instrumentation - from R&D up to Large Scale Manufacturing-type synthesizer, Cleavage systems, PreHPLC system, Column packing equipment and peptide production technical support.\n(3) Peptide raw material -- High Quality Standard Grade and High Grade Fmoc-protected Amino Acid, peptide reagents, coupling reagents, resins and special reagents, supported by relevant validated QC data, stability data and DMF technical documents.\n(4) DNA/RNA oligonucleotide synthesizers that can be used from research、process development and production.',
        'pepReag-RFDRS-sentence-3': 'CSBio (Shanghai) Ltd.',
        'pepReag-RFDRS-sentence-4': 'China (Shanghai) Pilot Free Trade Zone, 85 Faladi Road, Building 2,Room 502 ,Shanghai 201210, China\nEmail:info@csbiochina.com\nTel:+8621-50781653/50781655\nFax:+8621-50781652/021-50781656\nWebsite: www.csbiochina.com www.csbio.com',
        'qualAss': 'Quality Assurance',
        'qualAss-qualAss-sentence-1': 'Good Quality system is in the CSBio corporate culture and mission. We are committed to ensure full customer satisfaction by providing quality products and services to all our customers. All our staffs are highly trained in understanding how importance is quality meant to our customer and our company, and they are well versed in quality standards. We guarantee that our products and services are scrutinized with the most advanced testing techniques and validation prior to shipment to our customer so that our customer is trouble-less upon receipt of products and services. We can provide Certificate of Analysis, method of Analysis and actual quality data, shelf-life data. We will also work closely with our suppliers to ensure compliance to our in-house quality standards.\n\nOur COA will include the following one or more of the data (dependent on the characteristic and properties of the product)',
        'qualAss-qualAss-sentence-2': 'Besides abovementioned quality systems, we also try our best to support our customers in meeting the GMP or new drug registration requirement by providing the following technical documents:',
        'qualAss-qualAss-orderlist1-item1': 'Purity (HPLC)',
        'qualAss-qualAss-orderlist1-item2': 'TLC',
        'qualAss-qualAss-orderlist1-item3': 'Mass Spectrum（ESI）',
        'qualAss-qualAss-orderlist1-item4': 'NMR Spectrum',
        'qualAss-qualAss-orderlist1-item5': 'Chiral HPLC',
        'qualAss-qualAss-orderlist1-item6': 'Ion Chromatography',
        'qualAss-qualAss-orderlist1-item7': 'Specific rotation',
        'qualAss-qualAss-orderlist1-item8': 'Karl Fisher Titration',
        'qualAss-qualAss-orderlist1-item9': 'Acid-Base titration',
        'qualAss-qualAss-orderlist1-item10': 'UV/Vis',
        'qualAss-qualAss-orderlist1-item11': 'Metallic Analysis',
        'qualAss-qualAss-orderlist1-item12': 'Elemental Analysis',
        'qualAss-qualAss-orderlist1-item13': 'Amino Acid Analysis',
        'qualAss-qualAss-orderlist2-item1': 'Vendor Declaration Questionaire',
        'qualAss-qualAss-orderlist2-item2': 'TSE/BSE declaration',
        'qualAss-qualAss-orderlist2-item3': 'Non-GMO declaration',
        'qualAss-qualAss-orderlist2-item4': 'Route of Synthesis',
        'qualAss-qualAss-orderlist2-item5': 'Melamine Declaration',
        'qualAss-qualAss-orderlist2-item6': 'Declaration of Changes',
        'qualAss-qualAss-orderlist2-item7': 'Potential Impuritylist',
        'qualAss-qualAss-orderlist2-item8': 'Class-1 Solvents, fulfillment of regulatory requirements',
        'qualAss-qualAss-orderlist2-item9': 'Instrumentation listing',
        'qualAss-qualAss-orderlist2-item10': 'Raw material, solvent and catalyst listing',
        'qualAss-qualAss-orderlist2-item11': 'Material safety data sheet',
        'csbioAnalyServices': 'CSBio Analytical\nServices',
        'qualAss-CAS-sentence-1': 'CSBio strongly believed QUALITY and we will offer the qualified products to our global customers. Thus we have equipped our Quality control laboratories with necessary state-of-the analytical instrumentation. We can also provide analytical testing services to customers who like to outsource such services for the determination of product quality',
        'qualAss-CAS-orderlist-title1': 'MS spectrum analysis',
        'qualAss-CAS-orderlist-1-1': 'ESI-MS full scan',
        'qualAss-CAS-orderlist-1-2': 'LC-MS',
        'qualAss-CAS-orderlist-1-3': 'LC-MS-MS',
        'qualAss-CAS-orderlist-title2': 'HPLC purity analysis',
        'qualAss-CAS-orderlist-2-1': 'RP-HPLC (reversed phase)',
        'qualAss-CAS-orderlist-2-2': 'SEC-HPLC (size exclusion)',
        'qualAss-CAS-orderlist-2-3': 'IE-HPLC (ion exchange)',
        'qualAss-CAS-orderlist-2-4': 'Method development and validation for Non-GMP and GMP projects',
        'qualAss-CAS-orderlist-title3': 'NMR spectrum analysis',
        'qualAss-CAS-orderlist-title4': 'FT-IR spectrum analysis',
        'qualAss-CAS-orderlist-title5': 'Chiral HPLC analysis',
        'qualAss-CAS-orderlist-title6': 'Amino acid analysis',
        'qualAss-CAS-orderlist-6-1': 'Proteins/peptides are hydrolyzed using HCl. The released amino acid residues are analyzed on a reversed phase HPLC after pre-column derivatization.',
        'qualAss-CAS-orderlist-title7': 'Water Content',
        'qualAss-CAS-orderlist-7-1': 'Moisture Analysis by Karl Fisher titration',
        'qualAss-CAS-orderlist-title8': 'Peptide content',
        'qualAss-CAS-orderlist-8-1': 'by elemental analysis',
        'qualAss-CAS-orderlist-title9': 'Peptide counter ion content',
        'qualAss-CAS-orderlist-9-1': 'qualitative and quantitative analysis',
        'qualAss-CAS-orderlist-title10': 'Residual Solvent content',
        'qualAss-CAS-orderlist-10-1': 'DMF, DCM, ACN content by GC',
        'qualAss-CAS-orderlist-title11': 'Melting Point',
        'qualAss-CAS-orderlist-title12': 'Elemental Analysis',
        'qualAss-CAS-orderlist-12-1': 'C%, H%, and N% of organic compounds',
        'qualAss-CAS-orderlist-title13': 'Peptide API chemical testing',
        'qualAss-CAS-orderlist-title14': 'Lyophilization services',
        'preHplcAndCol': 'Prep-HPLC\nSystem',
        'phac-phhs-sentence-1': 'CSBio provides users with different sizes of high pressure liquid phase preparation systems and chromatographic columns. Applications include preparation and separation of fermentation drugs, natural products and peptides drugs, intermediates and chemical intermediates.',
        'phac-phhs-sentence-2': 'CSBio’s addition purification equipment to our line of automated peptide synthesis synthesizers allows us to provide COMPLETE service and equipment from peptide synthesis through final purification.',
        'semiPrepHplcSys': 'Semi-Prep HPLC\nSystem',
        'phac-sphs-sentence-1': 'GL6000 Series from 25ml to 250ml maximum flow pump head, SAC & DAC ID 25.4mm-100mm',
        'phac-sphs-sentence-2': 'System Configuration',
        'pilotPreHplcSys': 'Pilot-Prep\nHPLC Systems',
        'phac-pphs-sentenct-1': 'GL6000 Series from 500ml to 1L maximum flow pump head, DAC ID 100mm-200 mm PrepHPLC column',
        'phac-pphs-sentenct-2': 'System Configuration',
        'indusPrepHplcSys': 'Industrial-Prep\nHPLC Systems',
        'phac-iphs-sentenct-1': '● GL6000 Series from 2L to 2 ma 0Lximum flow pump head, DAC ID 200-800 mm PrepHPLC column\n\n● Explosion Proof Diaphragm pump\n\n● System hardware and software support GMP / 21CRF11, 3Q.',
        'phac-iphs-sentenct-2': 'Industrial-Prep\nHPLC Systems',
        'csbioProdListTitle-1': 'CSBio',
        'csbioProdListTitle-2': 'Product List',
        'instru-ncsbio-title-1': 'CSBio New product Release CSBio II Research Scale Peptide Synthesizer',
        'instru-ncsbio-content-1': 'The CSBio II is a fully featured automated peptide synthesizer for making peptides in the 50mg to 500mg scale.\n\nThe most affordable automated peptide synthesizer for research scale use in the market, CSBio II is designed to be `easy to operate with no hassle\' for users with no previous synthesis experience giving them the ability to easily start making peptides within their own lab.',
        'instru-ncsbio-title-2': 'CSBio II Peptide Synthesizer',
        'instru-cs136-sentence-1': 'The CS136 series features research scale peptide synthesizers that can be used for R&D, process development, and small-scale manufacturing. It has reaction vessel sizes ranging from 10mL to 250 mL and it uses 180° inversion mixing for complete resin to solvent contact. The CS136 series also offers UV options for deprotection monitoring and heating options for any part of the synthesis including critical washing steps, couplings, and deprotection cycles.',
        'instru-cs136-sentence-2': 'The CS136M is used for R&D and high volume small-scale manufacturing. Available with reaction vessel sizes ranging from 20 ml to 100 ml that utilize our patented 180° inversion for complete solvent and resin contact, the CS136M is custom built to order and can be customized to user needs. Standard options include jacketed reaction vessels for heating control, automated software integrated heated circulation, UV monitoring, and a touchscreen mounted computer for ease of use.',
        'instru-cs536-sentence-1': 'The CS536 is designed for pilot scale, single batch manufacturing and is widely used for process development and scale up. With a larger synthesis scale than our CS136 series, the CS536 can be supplied with either 180° inversion mixing or overhead stirring.',
        'instru-cs936-sentence-1': 'The CS936 series features CSBio\'s large scale commercial systems;the CS936S,CS936, and CS936X.The smaller CS936S system has reaction vessel sizes from 500ml to 5L while the CS936X has the largest reaction vessel ranging from 50L to 1000L. These commercial scale systems are the largest automated peptide synthesizers available worldwide',
        'instru-drs-sentence-1': 'The CS-OLIGO-D from CSBio is a fully automated DNA/RNA oligonucleotide synthesizers that can be used from research, process development and production.\nThis system is equipped with a reaction vessel that has 180° inversion mixing, flow through, and reaction vessel recirculation capabilities. This allows for batch synthesis with high load resin swelling, traditional flow through DNA synthesis, and recirculation for RNA synthesis.',
        'home-about-our-company': 'About Us Company',
        'home-content-1': 'Instrumentation',
        'home-content-2': 'Peptide',
        'home-content-3': 'Peptide Reagent',
        'home-content-4': 'Quality Management',
        'home-content-5': 'Prep-HPLC System',
        'home-content-6': 'Shanghai Wechat',
        'pageMgr': 'Page Management',
        'carouselMgr': 'Carousel Management',
        'deleteConfirm': 'Confirm Delete!?',
        'agent': 'Agent',
        'agent-index-sentence-1': 'PEPTIDE INSTITUTE',
        'agent-index-sentence-2': 'CSBio (Shanghai) Ltd is PEPTIDE INSTITUTE Sole Distributor in China since July 2015.\n\nPeptide Institute, Inc. traces its beginnings to the Protein Research Foundation since 1958. For more than half a century, Peptide Institutes have been widely contributing to the advancement of life sciences through research on amino acids, peptides and carbohydrates. Catalog Products',
        'agent-index-sentence-3': 'If you are interested in Peptide Institute\'s Products and Services, please do not hesitate CSBio (Shanghai) Ltd office using the following contact information:',
        'agent-index-sentence-4-title': 'Biologically Active Peptides and Proteins',
        'agent-index-sentence-4-content': '● Enzyme Inhibitors and Substrates\n● Carbohydrates and Conjugates\n● Peptide Antisera and Monoclonal Antibodies\n● Amino Acids and Amino Acids Derivatives\n● Reagents for Peptide Synthesi',
        'agent-index-sentence-5-title': 'Custom Synthesis for Basic Research',
        'agent-index-sentence-5-content': '● Peptides and Peptide-Modified Derivatives (Phosphorylated Peptides, Glycopeptides, Fluorescently-Labeled Peptides, etc.)\n● Preparation of Epitope Peptides, Bioconjugates and Polyclonal Antibodies\n● Glucolipids, Nucleotidyl Sugars, Sugar Related Compounds, etc.\n● Other Organic Compounds for Bio Research',
        'agent-index-sentence-6-title': 'Custom Synthesis for Drugs Development Research',
        'agent-index-sentence-6-content': '● Pharmaceuticals\n● Intermediates of Pharmaceuticals\n● Protected Peptides and Amino Acids Derivatives for Pharmaceuticals\n● GMP Peptides for Clinical Study',
        'agent-index-sentence-7-title': 'Website& Contact information',
        'agent-index-sentence-7-content': '● Peptide Institute :www.peptide.co.jp/en/\n● CSBio (Shanghai) Ltd: www.csbiochina.com\n● Address: China (Shanghai) Pilot Free Trade Zone, 85 Faladi Road, Building 2, Room 502 ,Shanghai 201210, China\n● Email：info@csbiochina.com',
        'agent-index-sentence-8-title': 'China Mainland, Hong Kong, Macau Sales Managers',
        'agent-index-sentence-8-content': '● Joanna Lu Mobile：+86-13761860314\n● Email: joanna.lu@csbiochina.com\n● Allen Chao Mobile：+86-13482222180\n● Email: qing.chao@csbiochina.com',
        'forgetPassTitle': 'Forget Password？',
        'resetPass': 'Reset Password',
        'rtnLoginPage': 'Return Login Page',
        'NewsMgr': 'News Management',
        'showDate': 'Show Date',
        'defaultImmediateShow': 'Default Immediate Show',
        'ifShow': 'Show',
        'defaultShow': 'Default Show',
        'articleTitle': 'Article Ttile',
        'articleNew': 'Create Article',
        'articleEdit': 'Edit Article',
        'newProdList': 'New Product List',
        'newProdMgr': 'New Product Management',
        'releaseDate': 'Release Date',
        'orderFailMsg': 'Order fail. Contact us, Please.',
        'orderSuccess': 'Order Success!!',
        'gotoOrderDetail': 'Go To Order Detail',
        'submit': 'Submit',
        'addToCart': 'Add To Cart',
        'year': 'year',
        'month': 'month',
        'yourCart': 'Your Cart',
        'orderRecord': 'order record',
        'more': 'MORE',
        'langTw': '繁體',
        'langCn': '简体',
        'langEn': 'English',
        'career': 'Career',
        'ourhonor-sentence-1': 'A method for inverse phase separation and derivatization of leucine and isoleucine',
        'ourhonor-sentence-2': 'The utility model relates to a production type automatic synthesizer for nucleic acid, DNA / RNA',
        'ourhonor-sentence-3': 'CSBio has obtained more than 20 utility model patents',
        'ourhonor-sentence-4': 'China Biochemical Pharmaceulial Industry Association Council Members',
        'ourhonor-sentence-5': 'Shanghai Bophamaceutics Industy Asociation member unit',
        'ourhonor-sentence-6': 'High and New Technology Enterprise Certificate',
        'ourhonor-sentence-7': '2017 WeChat Annual Enterprise',
        'antiBodyProdTitle': 'Antibody Product',
        'detail_name': 'field name',
        'detail_val': 'field value',
        'detail_new': "new field",
        'qtyPrice_name': 'qty',
        'qtyPrice_val': 'price',
        'qtyPrice_new': "new qty",
    },
}

let lang = document.querySelector('html').lang

/**
 *
 * @param text
 * @returns {*}
 * @private
 */
export function _(text) {
    return transTable[lang][text]
}

export {
    transTable
}
